// extracted by mini-css-extract-plugin
export default {"navbar":"NavigationBar_navbar__MpBeN"};